<template>
	<div class="FilterItem item filter" :class="filter.type" :data-cy="'filteritem-' + filter.field"
		@click="$emit('click', $event)"
		@dblclick="$emit('dblclick', $event)"
		v-if="filter.type != 'Hidden'"
	>
		<label class="name">
			{{ $t(`text.filterItem_${filter.field}`) }}
		</label>

		<span class="mode" v-if="modes?.length">
			<select v-model="filter.mode" class="filteritem-mode" data-cy="filteritem-mode">
				<option v-for="mode in modes" :key="mode" :value="mode">{{ i18n[mode] }}</option>
			</select>
		</span>

		<input class="value" type="text" v-model="filter.value" v-if="filter.type == 'Symbol' && !filter.in" ref="mainInput" :style="{ width: (length + 3) + 'ch' }" data-cy="filteritem-input" />

		<select class="value" v-model="filter.value" ref="mainInput" v-if="(filter.type == 'Symbol' || filter.type == 'SymbolList') && filter.in && isArray(filter.in)" data-cy="filteritem-input">
			<option v-for="val of filter.in" :key="val" :value="val">{{ val }}</option>
		</select>

		<select class="value" v-model="filter.value" ref="mainInput" v-if="(filter.type == 'Symbol' || filter.type == 'SymbolList') && filter.in && isObject(filter.in)" data-cy="filteritem-input">
			<option v-for="(option, o) of filter.in" :key="'fo-' + o" :value="o">{{ option }}</option>
		</select>

		<input class="value" type="text" v-model="filter.value" ref="mainInput" v-if="filter.type == 'Array' && filter.itemType == 'Link'" data-cy="filteritem-input" />

		<!-- TODO: i think these types dont actually exist -->
		<input class="value" type="text" v-model="filter.value" ref="mainInput" :style="{ width: (length + 3) + 'ch' }" v-if="filter.type == 'Url' || filter.type == 'Slug'" data-cy="filteritem-input" />
		<input class="value" type="number" v-model="filter.value" ref="mainInput" :style="{ width: ((filter.value + '').length + 3) + 'ch' }" v-if="filter.type == 'Number' || filter.type == 'Integer'" data-cy="filteritem-input" />
		<input class="value" type="date" v-model="filter.value" ref="mainInput" :style="{ width: (filter.value.length + 3) + 'ch' }" v-if="filter.type == 'Date'" data-cy="filteritem-input" />
		<select class="value" v-model="filter.value" :style="{ width: (length + 3) + 'ch' }" v-if="filter.type == 'Boolean'" data-cy="filteritem-input">
			<option value="true">{{ $t('text.yes') }}</option>
			<option value="false">{{ $t('text.no') }}</option>
		</select>
		<input class="value" type="text" v-model="filter.value" ref="mainInput" :style="{ width: (length + 3) + 'ch' }" v-if="filter.type == 'Text' || filter.type == 'RichText'" data-cy="filteritem-input" />
		<select class="value" v-model="filter.value" ref="mainInput" v-if="filter.type == 'User'" :style="{ width: (14 + 4) + 'ch' }" data-cy="filteritem-input">
			<option v-for="user of users" :key="user.sys.id" :value="user.sys.id">{{ user.firstName }} {{ user.lastName }}</option>
		</select>
		<div style="display: flex; justify-content: center; align-items: center; margin: 0 2px;">
			<v-icon @click="$emit('remove')" :size="18">mdi-close</v-icon>
		</div>
	</div>
</template>

<script lang="ts">

// TODO
function storageForFilter() {}

// TODO: support Link types - should be picker of certain types
// TODO: support location search? CF doesnt support it, but i think we could offer a map with radius

export default {
	name: 'FilterItem',
	props: {
		// { id: 0.23237938279, field: 'updatedAt', type: 'Date', scope: 'sys', mode: 'is', value: '2022-12-22', query: { k: 'sys.updatedAt[lt]', v: '2022-12-22' } })
		filter: Object,
	},
	data() {
		return {
			symbolModes: ['eq', 'ne', 'match'],
			symbolInModes: ['eq', 'ne'],
			continualModes: ['eq', 'ne', 'lt', 'lte', 'gt', 'gte'],
			symbolListModes: [ 'in', 'nin' ],
			linkListModes: [ 'in', 'nin', 'all' ],
			i18n: {
				is: this.$t('text.filterItemOperatorIs'),
				eq: this.$t('text.filterItemOperatorIs'),
				ne: 'is not',
				lt: 'is less than',
				lte: 'is less than or equal to',
				gt: 'is greater than',
				gte: 'is greater than or equal to',
				match: 'matches',
				in: 'include',
				nin: 'dont include',
				all: 'include all of',
			},
		}
	},
	computed: {
		length() {
			return Math.min(this.filter.value.length, 25)
		},
		users() {
			return Object.values(window.userLookup)
		},
		modes() {
			if (this.filter.type == 'Symbol' && !this.filter.in) return this.filter.modes || this.symbolModes
			if (this.filter.type == 'Symbol' && this.filter.in) return this.filter.modes || this.symbolInModes
			if (this.filter.type == 'SymbolList') return this.symbolListModes
			if (this.filter.type == 'Array') return this.linkListModes
			if (this.filter.type == 'Number' || this.filter.type == 'Integer' || this.filter.type == 'Date') return this.continualModes
			return []
		},
		arrayValue() {
			return this.filter.value?.split?.(',')?.filter(i => !!i) ?? []
		},
	},
	watch: {
		// map the ui settings to query params
		'filter.mode'(n, o) {
			this.buildQuery()
		},
		'filter.value'(n, o) {
			this.buildQuery()
		},
		value(n, o) {
			this.buildQuery()
		},
	},
	methods: {
		// TODO: we should actually move this mapping into EntryApi - doesnt make sense to build it in the ui in prod.
		buildQuery() {
			let queryMode = '[' + this.filter.mode + ']'
			if (this.filter.mode == 'eq') queryMode = ''
			if (this.filter.type == 'Text') queryMode = '[match]'
			if (this.filter.type == 'RichText') queryMode = '[match]'
			//const prefix = this.filter.scope == 'fields' ? '' : (this.filter.scope + '.')
			const prefix = this.filter.scope + '.'
			let key = prefix + this.filter.field
			if (this.filter.type == 'User') key += '.sys.id'
			if (this.filter.type == 'Array' && this.filter.itemType == 'Link') key += '.sys.id'
			key += queryMode
			if (!this.filter.query) this.filter.query = {}
			this.filter.query.k = key
			this.filter.query.v = this.filter.value
			this.filter.storage = storageForFilter(this.filter)
		},
		isArray(o) { return typeof o == 'object' && Array.isArray(o) },
		isObject(o) { return typeof o == 'object' && !Array.isArray(o) },
	},
	async mounted() {
		if (this.filter.focus) {
			this.$nextTick(() => {
				this.$refs.mainInput?.focus()
				this.filter.focus = false
			})
		}
		this.buildQuery()
	},
}
</script>

<style scoped>
.item { display: flex; align-items: center; font-size: 13px; padding-left: 10px; border-radius: 4px; }
.item:hover { outline: 1px solid var(--primary); }
.item > label { user-select: none; }
/* TODO: add a down arrow on the select on safari - i think we'll need to add an addl element */
.item > input,
.item > button,
.item > select { text-align: center; line-height: 1.25rem; border-radius: 4px; font-family: var(--font-stack-primary); font-size: 13px; line-height: 18px; -webkit-appearance: none; }
.item > button { padding-left: 10px; padding-right: 10px; }
.filter.selected { outline: 1px solid var(--primary); }
.item .mode { position: relative; margin-left: 8px; }
.item .mode .filteritem-mode { padding: 0 8px; }
.item .mode::after { content: ' '; z-index: 1; position: absolute; width: 50%; right: 0; top: 0; bottom: 0; }
.item .mode select { background: white; color: var(--col); border: 0; position: relative; z-index: 2; appearance: none; text-align: center; border-radius: 4px; font-size: 13px; line-height: 18px; font-weight: normal; }
input[type="date"] { min-width: 120px; }
.item .name { background-color: #AAE4FA; border-radius: 4px; padding: 0 8px; }
.item > *.value { margin: 0 8px; }

::-webkit-calendar-picker-indicator { background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 24 24"><path fill="black" d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"/></svg>'); }
</style>

<style>
/* we style this globally because EntryFilter has a Content Type control */
.FilterItem {
	background-color: #F4F4F4;
	color: #333;
	--bg: var(--color-element-light);
	--col: #333;
	font-weight: bold;
}
.FilterItem label { font-weight: normal; }
.FilterItem .mode { color: var(--col); font-weight: normal; }
.FilterItem .mode::after { background: var(--bg); }
.FilterItem input,
.FilterItem button,
.FilterItem select { background-color: #C1C1C1; color: #000; font-weight: 400; line-height: 18px; }
</style>